<template>
    <div>


        <div class="modal" style="display: block">
            <div class="modal-dialog modal-lg" role="document">

                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title abtg__label-color-custom" id="exampleModalLabel"
                            style="font-weight:bold;margin-top:-8px; font-size:100% !important;">
                            Operazioni</h5>
                        <button type="button" class="close" data-dismiss="modal" @click="closeModal()"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="modal-body">

                            <div class="row">
                                <div class="col">
                                    <div class="table-responsive">
                                        <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                                            <thead>
                                            <tr>
                                                <th class="mdl-data-table__cell--non-numeric text-left">
                                                    Operazione n.
                                                </th>


                                                <th class="mdl-data-table__cell--non-numeric text-left">
                                                   Capitale Proprio
                                                </th>


                                                <th class="mdl-data-table__cell--non-numeric text-left">

                                                </th>



                                            </tr>
                                            </thead>
                                            <tbody>


                                            <tr v-for="(u, index) in content.operationList">
                                                <td>
                                                    {{u.operazione_id}}
                                                </td>
                                                <td>
                                                    {{u.capitale_proprio}}
                                                </td>
                                                <td>
                                                    <a @click="createUrl(u)"><i class="fas fa-eye"></i></a>
                                                </td>
                                            </tr>


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>


                    </div>
                    <div class="modal-footer">

                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>


    export default {
        props: ['content'],
        components: { },
        data: function () {
            return {

            }
        },

        computed: {

        },
        created: function () {

        },
        methods: {
            createUrl: function(u)
            {
                this.$emit('assign-member', u);
            },
            closeModal: function()
            {
                this.$emit('close-modal');
            }
        }
    }
</script>